import { j as t } from "../../../../_virtual/jsx-runtime.js";
import '../../../../node_modules/leaflet/dist/leaflet.css';import '../../../../node_modules/react-loading-skeleton/dist/skeleton.css';import '../../../../index.css';/* empty css                    */
import h from "../../../atoms/BaseCard/index.js";
import j from "../../../atoms/BaseCardHeader/index.js";
import "../../../atoms/Button/index.js";
import { cn as g } from "../../../../lib/utils.js";
import "../../../atoms/Icon/index.js";
import "react";
/* empty css                                                                */
import "../../../atoms/SearchBar/index.js";
import "../../../atoms/FormElements/Input/index.js";
import "../../../atoms/FormElements/CheckboxInput/index.js";
import "../../../atoms/FormElements/Textarea/index.js";
import "../../../atoms/FormElements/ToggleInput/index.js";
import C from "../../../atoms/charts/MixedChart/index.js";
import "../../../ui/chart.js";
import A from "../../../atoms/charts/Legend/index.js";
import "../../../ui/calendar.js";
import "../../../ui/dropdown-menu.js";
import "../../../../assets/icons/index.js";
import "../../../ui/dialog.js";
import "../../../ui/button.js";
import { rightAxis as u, leftAxis as N } from "./utils.js";
import "../../../ui/table.js";
import "../../../../_virtual/index.js";
/* empty css                                                */
import "../../../organisms/map/Map/customMapComponents.js";
import "../../../organisms/WingCard/utils.js";
import { YAxis as w } from "../../../../node_modules/recharts/es6/cartesian/YAxis.js";
const _ = ({
  title: i,
  subtitle: r,
  headerContent: e,
  leftAxis: m,
  rightAxis: o,
  xAxisTickFormatter: s,
  data: p,
  config: a,
  legendConfig: n,
  onLegendClick: x,
  className: l,
  isLoading: f,
  xAxisTicks: c,
  ...d
}) => /* @__PURE__ */ t.jsxs(h, { children: [
  /* @__PURE__ */ t.jsx(
    j,
    {
      leftIconProps: { iconName: "TimeLine" },
      title: i,
      size: "base",
      subtitle: r,
      subtitleClassName: "mt-0",
      leftContentClassName: "flex flex-row gap-4",
      rightContentClassName: "flex flex-1 justify-between items-center",
      className: g("gap-10", l),
      isLoading: f,
      children: e
    }
  ),
  /* @__PURE__ */ t.jsxs("div", { className: "mt-2 p-0", children: [
    /* @__PURE__ */ t.jsx(
      C,
      {
        ...d,
        data: p,
        config: a,
        xAxis: { dataKey: "time", tickFormatter: s, ticks: c },
        leftAxis: { ...N, ...m },
        rightAxis: {
          ...u,
          ...o
        },
        children: /* @__PURE__ */ t.jsx(w, { yAxisId: "motion", domain: [0, 10], hide: !0 })
      }
    ),
    /* @__PURE__ */ t.jsx("hr", { className: "-mt-4 w-3/4 justify-self-center" }),
    /* @__PURE__ */ t.jsx(A, { config: n, onClick: x })
  ] })
] });
export {
  _ as default
};
